// CSS Modules - component class name prefix: ProductArea__

<template>
  <nav :class="$style.container">
    <ul :class="[$style.menu, 'columns is-gapless']">
      <li
        v-for="link in productLinks"
        :key="link.id"
        :class="[$style.menuItem, 'column']"
        v-tippy="{
          theme: 'wika light',
          interactive: true,
          reactive: true,
          placement: 'top',
          flip: false,
          animation: 'fade',
          duration: [200, 600],
          animateFill: false,
          arrow: false,
          distance: 0,
          html: '#productArea-' + link.id
        }"
        @init="initProductAreaPopper"
      >
        <a :href="link.url"
          ><span>{{ link.title }}</span></a
        >
      </li>
    </ul>
    <div
      v-for="link in productLinks"
      :key="link.title + link.id"
      :id="'productArea-' + link.id"
      :class="$style.popupContent"
    >
      <h2>{{ link.title }}</h2>
      <div class="columns is-variable is-8">
        <div class="column is-one-third">
          <p v-html="link.text"></p>
        </div>
        <div :class="[$style.cloud, 'column is-two-thirds']">
          <vue-word-cloud
            :words="link.words || [[]]"
            font-family="Helvetica, Arial"
            :animation-duration="0"
            :spacing="0.5"
            :font-size-ratio="3"
          >
            <template slot-scope="slotProps">
              <a
                :title="slotProps.weight"
                :href="slotProps.word[2]"
                :class="$style.tag"
                :target="getLinkTarget(slotProps.word)"
              >
                {{ slotProps.text }}
              </a>
            </template>
          </vue-word-cloud>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import VueWordCloud from "vuewordcloud";

export default {
  name: "ProductArea",
  components: {
    "vue-word-cloud": VueWordCloud
  },
  props: {
    productLinks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    initProductAreaPopper(tippy) {
      tippy.popper.id = "productAreaPopper";
    },
    getLinkTarget(propsArr) {
      return propsArr[3] ? "_blank" : "_self";
    }
  }
};
</script>

<style module lang="scss">
@import "./ProductArea.scss";
</style>
